import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/auth/auth.module').then( m => m.AuthPageModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.module').then( m => m.MainPageModule), canActivate: []
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'external-detail-request',
    loadChildren: () => import('./pages/external-detail-request/external-detail-request.module').then( m => m.ExternalDetailRequestPageModule)
  },
  {
    path: 'external-pratica-access',
    loadComponent: () => import('./pages/external-pratica-access/external-pratica-access.page').then( m => m.ExternalPraticaAccessPage)
  },

 


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
